import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DialogComponent } from '@src/app/shared/components/dialog/dialog.component';
import { SharedModule } from '@src/app/shared/shared.module';

export interface ConfirmLiquidationData {
  settlementDate: string;
  settlementNotional: string;
  settlementSpot: string;
  settlementRate: string;
  totalAmount: number;
  withholdingTax: number;
  incomeTaxPayable: number;
  netAmount: number;
}

@Component({
  selector: 'app-modal-confirm-liquidation',
  templateUrl: './modal-confirm-liquidation.component.html',
  styleUrls: ['./modal-confirm-liquidation.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule],
})
export class ModalConfirmLiquidationComponent {
  @ViewChild('dialog') dialogRef!: DialogComponent;
  @Output() confirmLiquidation = new EventEmitter<void>();

  data: ConfirmLiquidationData | null = null;

  open(data: ConfirmLiquidationData): void {
    this.data = data;
    this.dialogRef?.open(
      '',
      '',
      'Confirmar Liquidação da Operação',
      'Cancelar',
      '',
      'confirm-liquidation-operation',
      false,
      false
    );
  }

  close(): void {
    this.dialogRef?.close();
  }

  handleConfirm(): void {
    this.confirmLiquidation.emit();
    this.close();
  }
}
